<div class="ambassador-popup-modal" [class.ambassador-popup-modal--no-image]="!hasPopupImage()">
  <app-enfaf-icon class="close-button" svgIconName="x-circle" (onClick)="onCloseClick($event)" [isButton]="true" iconSize="40px" />

  @if (hasPopupImage()) {
    <div class="modal-content modal-content--with-image" (click)="onModalClick()">
      <div
        class="popup-background-image"
        [style.background-image]="'url(' + getPopupImageUrl() + ')'"
        role="img"
        [attr.aria-label]="getDescription()"
      >
      </div>

      @if (getDescription()) {
        <div class="popup-description-banner">
          <p class="popup-description-text">
            {{ getDescription() }}
          </p>
        </div>
      }
    </div>
  } @else {
    <div class="modal-content modal-content--no-image">
      <div class="popup-text">
        <h2 class="popup-title">Embajador ENFAF</h2>

        @if (getDescription()) {
          <p class="popup-description">
            {{ getDescription() }}
          </p>
        }
      </div>
    </div>
  }
</div>
